import { render, staticRenderFns } from "./CustomerSales.vue?vue&type=template&id=4cbe3b9e&scoped=true&"
import script from "./CustomerSales.vue?vue&type=script&lang=js&"
export * from "./CustomerSales.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSales.vue?vue&type=style&index=0&id=4cbe3b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbe3b9e",
  null
  
)

export default component.exports